export function SectionHeader(props) {
    return (
        <>
            <div className="divider"/>
            <h2 className="section-title">{props.title}</h2>
            <p className="section-sub">{props.sub}</p>
        </>
    );
}